import React, { Component } from "react";

import contactProvider from "../../../../../static/images/contactProvider.svg";
import MainTemplate from "../../mainTemplate";
import Tabs from "../../tableProvider/tabs";

import userCard from "../../../../../static/images/user-card.svg";
import userContact from "../../../../../static/images/user-contact.svg";
import userBills from "../../../../../static/images/user-bills.svg";

import ProfileInfo from "../profile/profileInfo";
import ProfileAccount from "../profile/profileAccount";

class Profile extends Component {
  render() {
    return (
      <MainTemplate>
        <div className="profile">
          <img src={contactProvider} className="icon" />
          <p className="pUser">Gestión de Usuarios</p>
          
          <Tabs>
            <div label="Perfil de Empresa" image={userCard}>
              <div className="client-info">
                <ProfileInfo />
              </div>
            </div>
            <div label="Usuarios" image={userContact}>
              <div className="user-list">
                {/* <TableUsers /> */}
              </div>
            </div>
            <div label="Cuentas" image={userBills}>
              <ProfileAccount />
            </div>
          </Tabs>
        </div>
      </MainTemplate>
    );
  }
}

export default Profile;
